module.exports = __webpack_public_path__ + "static/img/QA.43728edd.svg";